<input id="typeahead-format" type="text" class="form-control"   placeholder="{{ 'lblSearchDealer' | translate }}" name="searchDealer"
    [resultFormatter]="formatter" (selectItem)="setDealer($event)" [(ngModel)]="input" [disabled]="disabled"
    (ngModelChange)="onChange($event)" (blur)="onTouched($event)"
    [ngbTypeahead]="search"
    (keydown)="typeaheadKeydown($event)"
    #typeaheadInstance="ngbTypeahead"
    />